var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 183,
    viewBox: "0 0 152 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_886_16041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.701 49.9561C105.701 49.9561 105.628 49.9725 105.603 49.9807V49.9643C105.62 49.9561 105.677 49.9561 105.701 49.9561ZM86.6216 61.5329C88.1075 59.557 89.7158 57.7368 91.5364 56.0889C95.3491 52.6781 100.305 50.5382 105.595 49.9807C114.886 52.4157 121.433 59.516 125.956 68.2397C122.07 67.141 118.045 66.9442 114.314 67.4936C109.408 68.2397 105.073 69.9696 101.333 72.5031C97.0635 67.8789 92.0997 64.0664 86.6216 61.5329Z",
    fill: "url(#paint0_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6474 116.818C63.2476 115.613 65.0518 114.744 67.1092 114.391C71.0116 113.736 75.5672 115.015 78.3186 118.835C78.0981 118.45 77.845 118.114 77.6246 117.753C78.1471 118.483 78.7186 119.196 79.1758 119.975C84.058 128.157 84.3764 138.021 83.511 147.023C83.2742 149.458 82.9803 151.861 82.6211 154.287C82.4986 155.05 82.3516 155.78 82.1965 156.55C81.9353 158.239 81.6495 159.961 81.2903 161.625C80.4004 166.077 79.2493 170.497 77.8124 174.826C76.0408 174.44 74.2936 173.817 72.5383 173.022C73.5262 165.184 73.3466 157.141 71.9913 149.352C71.7709 148.073 71.4607 146.802 71.1831 145.531C70.5136 142.448 69.738 139.415 68.7094 136.438C67.2725 132.257 65.4764 128.256 63.3374 124.402C62.2352 122.336 61.0841 120.336 59.8921 118.36C60.4228 117.786 61.0269 117.302 61.6474 116.818Z",
    fill: "url(#paint1_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9941 65.0995C60.431 63.8942 62.0067 62.812 63.6477 61.8527C68.7095 59.0159 74.7101 58.3108 80.8414 59.6636C82.2293 59.9096 83.6172 60.2703 84.9643 60.7294C85.5439 60.9508 86.0828 61.2624 86.6216 61.5247C92.0997 64.0582 97.0635 67.8707 101.333 72.4949C104.689 76.1434 107.628 80.2675 109.955 84.6949C117.507 99.2316 119.319 115.843 116.225 130.838C113.016 146.375 104.264 161.847 93.1039 172.415C92.5569 172.94 91.9365 173.448 91.3323 173.973C91.0221 174.235 90.7118 174.531 90.3771 174.817C90.1403 174.99 89.9444 175.219 89.7076 175.4C88.1565 176.629 86.5155 177.761 84.801 178.843C83.8131 179.474 82.8089 180.098 81.7394 180.672C81.5762 179.147 81.4782 177.736 81.4292 176.482C81.8864 176.146 82.2864 175.752 82.7273 175.4C89.4137 169.956 94.8755 163.224 98.0106 154.681C103.252 140.366 99.7904 119.557 94.2061 105.094C92.5079 100.716 90.2955 96.3784 87.7809 92.4183C87.7074 92.2707 87.6339 92.1477 87.5441 92.0083C86.5073 90.4014 85.3643 88.901 84.1234 87.4661C82.8824 86.0477 81.5598 84.7031 80.1638 83.4979C79.5106 82.8747 78.8248 82.2926 78.1227 81.7597C74.7918 79.136 71.0852 77.1847 67.2399 76.1844C65.5826 75.7499 63.9089 75.4793 62.2108 75.4219C53.1813 75.1596 48.2501 83.957 48.6747 92.6889C48.4624 91.1721 48.3889 89.6798 48.3889 88.2122C48.4461 78.7917 52.6996 70.4534 58.9941 65.0995Z",
    fill: "url(#paint2_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1685 94.7058C52.5281 95.9602 56.7 97.928 60.4065 100.363C65.6724 103.823 69.3707 107.972 73.6324 112.44C75.1673 114.031 76.4899 115.81 77.6165 117.753C77.837 118.114 78.09 118.45 78.3105 118.835C75.5592 115.015 71.0036 113.735 67.1011 114.391C65.0438 114.736 63.2395 115.613 61.6393 116.818C61.0188 117.302 60.4147 117.786 59.884 118.36C59.2635 119.007 58.6594 119.729 58.1369 120.524C57.4184 121.557 56.7898 122.681 56.202 123.837C52.822 130.576 51.8097 139.046 53.4425 147.302C53.8181 149.278 54.3487 151.221 55.0263 153.107C57.0919 159.002 60.6759 164.364 65.1907 168.332C66.6929 169.677 68.3012 170.833 69.9994 171.825C70.8321 172.3 71.6812 172.661 72.5303 173.022C74.2856 173.817 76.0327 174.44 77.8043 174.826C77.3308 176.195 76.8654 177.54 76.3592 178.884C75.8367 180.18 75.2653 181.598 74.7101 182.902C73.5426 183.066 69.0523 183.016 67.5991 182.918C59.7126 182.418 51.5321 179.524 44.1435 175.318C42.6577 174.473 41.1718 173.571 39.7349 172.62C26.3947 163.749 14.8424 149.409 11.291 133.864C9.12754 124.312 10.5236 112.169 16.2548 103.913C23.8475 93.0086 36.5754 91.3442 48.1685 94.7058Z",
    fill: "url(#paint3_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9658 101.453C62.5863 93.7547 66.3418 83.9652 71.9996 77.9718C70.4484 77.2257 68.8809 76.6026 67.2399 76.1926C65.5825 75.7581 63.9089 75.4875 62.2107 75.4301C56.0713 75.2415 51.8341 79.259 49.8747 84.5965C49.7768 84.8917 49.6788 85.2032 49.5808 85.5066C49.54 85.605 49.5318 85.6952 49.491 85.7936C48.8379 88.1466 48.5766 90.5407 48.6746 92.697C48.6093 92.3363 48.6011 91.9755 48.5603 91.5984C48.6093 92.7216 48.7073 93.8285 48.8216 94.919C52.9363 96.1734 56.8877 98.0427 60.3983 100.355C60.9371 100.724 61.4678 101.085 61.9658 101.453Z",
    fill: "url(#paint4_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.308 78.4227C129.108 74.9136 127.646 71.5192 125.956 68.2397C121.433 59.5242 114.886 52.4076 105.595 49.9725C105.62 49.9561 105.668 49.9561 105.668 49.9561C108.118 49.5707 110.534 49.3248 112.992 49.4559C115.523 49.5707 118.119 49.9561 120.723 50.6038C122.429 51.0137 124.168 51.5713 125.834 52.2436C127.899 52.9405 129.883 53.8752 131.753 54.982C133.623 56.1053 135.378 57.4089 137.043 58.8519C139.697 61.2542 141.934 63.7877 143.779 66.4277C145.665 69.0924 147.175 71.8472 148.359 74.684C149.624 77.9554 150.539 81.235 151.159 84.4981C155.257 113.432 143.917 140.489 124.691 159.42C124.454 159.633 124.217 159.822 123.997 160.043C123.883 160.141 123.752 160.264 123.638 160.379C122.299 161.675 120.927 162.954 119.499 164.175C110.567 171.784 102.052 177.244 90.2219 180.319C86.9563 181.155 83.5682 181.86 80.18 182.393C79.2412 182.557 75.6734 182.82 74.7019 182.902C74.8978 181.459 75.2816 180.106 75.7959 178.81C76.2776 177.589 76.9226 176.334 77.8043 174.834C79.4534 175.195 81.0699 175.342 82.7354 175.416C89.2586 175.678 94.6224 172.874 99.9618 169.693C100.011 169.685 100.052 169.644 100.084 169.628C104.019 167.274 107.701 164.577 111.049 161.429C112.551 160.002 113.988 158.493 115.343 156.927C115.506 156.739 115.702 156.477 115.866 156.255C116.927 154.96 118.005 153.664 119.001 152.279C120.348 150.491 121.613 148.663 122.813 146.744C135.386 126.714 137.974 100.773 130.308 78.4227Z",
    fill: "url(#paint5_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5377 60.4097L30.289 56.63C28.4684 55.023 26.3621 53.7931 24.068 52.9978L23.1617 58.5977C24.7782 58.8355 26.2641 59.4914 27.5377 60.4097Z",
    fill: "url(#paint6_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3409 58.7043C20.0838 58.5403 20.8431 58.4583 21.5697 58.4583V52.3501C19.1939 51.891 16.6875 51.9156 14.1893 52.4895C13.9525 52.5387 13.7158 52.6043 13.4872 52.6617L16.9651 59.5734C17.7162 59.2044 18.5 58.9093 19.3409 58.7043Z",
    fill: "url(#paint7_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2115 71.8144L36.1753 73.4296C36.5754 71.1503 36.5182 68.7808 36.0121 66.3867L31.5871 67.0836C31.8484 68.7234 31.7014 70.3222 31.2115 71.8144Z",
    fill: "url(#paint8_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2361 65.5094L35.3753 64.1648C34.5834 61.9593 33.4077 59.9751 31.9463 58.2943L28.7623 61.4673C29.8645 62.5742 30.7217 63.9434 31.2361 65.5094Z",
    fill: "url(#paint9_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5854 60.4097L10.7033 53.6537C7.82947 54.9492 5.40472 56.9743 3.59229 59.4258L12.5239 64.0172C13.2586 62.5988 14.2955 61.3689 15.5854 60.4097Z",
    fill: "url(#paint10_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.823 78.5949C23.0637 78.7589 22.3126 78.8327 21.5697 78.8327V88.3106C21.8065 88.2696 22.0269 88.2368 22.2392 88.1876C25.0395 87.5399 27.5295 86.2855 29.6359 84.6211L26.158 77.7586C25.4232 78.1112 24.6557 78.4063 23.823 78.5949Z",
    fill: "url(#paint11_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5377 76.9059L31.7014 82.6534C33.4567 80.702 34.7956 78.3899 35.5876 75.8647L30.5993 73.3148C29.8808 74.7168 28.8358 75.963 27.5377 76.9059Z",
    fill: "url(#paint12_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6098 76.8895L8.95605 86.0805C11.7564 87.7449 14.9975 88.655 18.3693 88.6468L19.9532 78.7179C18.3693 78.4473 16.8834 77.8242 15.6098 76.8895Z",
    fill: "url(#paint13_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.936 65.5258L1.87779 62.2462C0.416412 65.2224 -0.23672 68.5922 0.0816818 72.0439L11.5768 70.2402C11.2992 68.6086 11.4462 67.0016 11.936 65.5258Z",
    fill: "url(#paint14_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9361 71.8062L0.726685 75.4629C1.73087 78.8983 3.64945 81.8417 6.1885 84.0554L14.4016 75.8483C13.2913 74.725 12.4422 73.3722 11.9361 71.8062Z",
    fill: "url(#paint15_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1649 44.2824L50.8381 47.5292C52.5608 48.9558 54.5447 50.1118 56.7082 50.8743L57.4756 46.0944C55.8591 45.832 54.3977 45.2007 53.1649 44.2824Z",
    fill: "url(#paint16_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5318 39.2401L45.5803 40.5437C46.4702 42.5688 47.6948 44.3972 49.2052 45.996L51.9565 43.2494C50.8544 42.1425 50.0134 40.7897 49.5318 39.2401Z",
    fill: "url(#paint17_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.962 44.3152L69.6074 50.735C72.5547 49.6281 75.159 47.808 77.2001 45.4713L67.9991 40.7487C67.2643 42.1671 66.2438 43.3887 64.962 44.3152Z",
    fill: "url(#paint18_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0675 46.2092V51.5221C59.9492 51.7106 60.8799 51.8746 61.8188 51.9238C63.5415 52.0386 65.2233 51.8746 66.8316 51.5466L63.5904 45.1515C62.227 45.832 60.6758 46.2337 59.0675 46.2092Z",
    fill: "url(#paint19_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9784 27.9748L73.118 16.734C70.4892 15.0532 67.4195 14.0202 64.113 13.807C63.615 13.7824 63.1088 13.7988 62.6271 13.7988L60.6595 26.171C62.2516 26.417 63.7129 27.0565 64.9784 27.9748Z",
    fill: "url(#paint20_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0338 35.5342C49.0991 34.6487 49.2542 33.8206 49.5155 33.0335L44.0373 31.2543C44.0373 31.3937 43.9965 31.5659 43.9884 31.7299C43.8496 34.042 44.1516 36.2803 44.7966 38.3956L49.1399 37.7151C49.0256 37.0018 49.0011 36.2721 49.0338 35.5342Z",
    fill: "url(#paint21_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1013 36.7558C69.0523 37.6249 68.8809 38.4612 68.6196 39.2729L79.2248 42.7328C80.776 40.183 81.7476 37.215 81.9517 34.0174C81.9762 33.5336 81.968 33.0499 81.968 32.5662L69.0115 34.6077C69.1013 35.2882 69.134 36.0097 69.1013 36.7558Z",
    fill: "url(#paint22_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1142 19.0953L66.1866 29.016C67.2725 30.1393 68.1297 31.5003 68.6277 33.0171L81.5107 28.811C80.7025 25.0641 78.7839 21.6944 76.1142 19.0953Z",
    fill: "url(#paint23_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0675 26.0644V14.2088C55.7202 14.9221 52.6995 16.4717 50.2502 18.71L54.5201 27.1549C55.8835 26.4416 57.4184 26.0644 59.0675 26.0644Z",
    fill: "url(#paint24_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1404 27.9911L48.1031 20.9975C46.356 23.1866 45.1069 25.7938 44.4619 28.6307L50.1197 31.5495C50.8299 30.1393 51.8831 28.9094 53.1404 27.9911Z",
    fill: "url(#paint25_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.02 22.0059C106.011 20.7843 106.207 19.6282 106.55 18.546L101.807 16.9882C101.635 18.0459 101.562 19.1281 101.562 20.2186C101.586 21.5632 101.733 22.8832 102.019 24.1459L106.158 23.4899C106.085 22.998 106.02 22.5061 106.02 22.0059Z",
    fill: "url(#paint26_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55 25.1543L102.64 26.4251C103.407 28.6634 104.574 30.7132 106.019 32.5087L109.138 29.3849C107.979 28.1961 107.073 26.7531 106.55 25.1543Z",
    fill: "url(#paint27_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.845 32.5415C116.796 32.5415 116.731 32.5251 116.674 32.5251V39.2811C118.298 39.6828 119.98 39.9042 121.727 39.8796C123.042 39.855 124.332 39.7074 125.556 39.445L121.491 31.3855C120.086 32.0906 118.519 32.5169 116.845 32.5415Z",
    fill: "url(#paint28_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.428 30.4836L107.652 34.3125C109.473 36.0507 111.636 37.4855 114.02 38.4284L114.984 32.394C113.302 32.1152 111.743 31.4593 110.428 30.4836Z",
    fill: "url(#paint29_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.183 17.9884L127.214 20.1939C127.287 20.6941 127.352 21.1778 127.352 21.678C127.361 22.8996 127.181 24.0638 126.83 25.1625L139.044 29.1554C140.529 26.3103 141.338 23.0718 141.289 19.6528C141.28 19.0707 141.215 18.5378 141.183 17.9884Z",
    fill: "url(#paint30_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.936 30.5164L128.708 38.4775C131.99 37.1739 134.839 35.034 136.994 32.3038L126.169 26.7285C125.401 28.2207 124.291 29.5325 122.936 30.5164Z",
    fill: "url(#paint31_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.952 13.1757L130.781 2.3285C127.908 0.795301 124.618 -0.0573868 121.131 5.68503e-06C120.797 5.68503e-06 120.478 0.0410003 120.144 0.0655971L118.364 11.2571C120.054 11.5359 121.613 12.2082 122.952 13.1757Z",
    fill: "url(#paint32_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.83 18.5378L140.407 14.094C139.256 10.2897 137.002 6.9527 134.006 4.50122L124.234 14.2743C125.418 15.4632 126.291 16.9062 126.83 18.5378Z",
    fill: "url(#paint33_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.42 13.1839L106.109 7.23965C104.403 9.33858 103.089 11.7901 102.329 14.4793L107.187 16.9636C107.938 15.4632 109.057 14.1677 110.42 13.1839Z",
    fill: "url(#paint34_linear_886_16041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.519 11.1096C116.519 11.1096 116.633 11.1259 116.666 11.1259V0.590332C113.473 1.36923 110.575 2.94342 108.191 5.08334L111.841 12.2984C113.253 11.5851 114.837 11.1505 116.519 11.1096Z",
    fill: "url(#paint35_linear_886_16041)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_886_16041",
    x1: 114.478,
    y1: 56.5387,
    x2: 99.2184,
    y2: 71.3439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#023242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2327,
    stopColor: "#07394A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3553,
    stopColor: "#104556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#1A576A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6053,
    stopColor: "#236F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    stopColor: "#247288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6465,
    stopColor: "#2A758B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#619CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_886_16041",
    x1: 73.7766,
    y1: 115.355,
    x2: 66.7173,
    y2: 174.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2625,
    stopColor: "#835F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#AA802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5383,
    stopColor: "#AF8531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#BC9542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8765,
    stopColor: "#D3B266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CC83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_886_16041",
    x1: 90.5307,
    y1: 141.44,
    x2: 76.7218,
    y2: 67.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_886_16041",
    x1: 74.4966,
    y1: 172.869,
    x2: 24.5423,
    y2: 100.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_886_16041",
    x1: 62.6918,
    y1: 75.6648,
    x2: 55.6147,
    y2: 98.0882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0883,
    stopColor: "#253F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2322,
    stopColor: "#304C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4137,
    stopColor: "#436432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5B833B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7877,
    stopColor: "#759A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99BF7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_886_16041",
    x1: 57.023,
    y1: 143.019,
    x2: 132.039,
    y2: 95.6922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00089684,
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0794,
    stopColor: "#B29A7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1534,
    stopColor: "#669FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1862,
    stopColor: "#28A0DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5541,
    stopColor: "#1E8FCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_886_16041",
    x1: -0.442337,
    y1: 73.6927,
    x2: 28.7914,
    y2: 54.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_886_16041",
    x1: -3.37961,
    y1: 69.0912,
    x2: 25.8421,
    y2: 50.3384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_886_16041",
    x1: 8.07298,
    y1: 86.9726,
    x2: 37.3193,
    y2: 68.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_886_16041",
    x1: 4.02766,
    y1: 80.4134,
    x2: 33.1479,
    y2: 61.7258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_886_16041",
    x1: -3.64319,
    y1: 68.5959,
    x2: 25.5231,
    y2: 49.8787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_886_16041",
    x1: 10.9135,
    y1: 91.2807,
    x2: 40.0806,
    y2: 72.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_886_16041",
    x1: 10.8078,
    y1: 91.145,
    x2: 40.0104,
    y2: 72.4045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_886_16041",
    x1: 8.83196,
    y1: 88.0497,
    x2: 37.9921,
    y2: 69.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_886_16041",
    x1: -1.67557,
    y1: 71.6765,
    x2: 27.5073,
    y2: 52.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_886_16041",
    x1: 3.4887,
    y1: 79.7372,
    x2: 32.6939,
    y2: 60.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD00E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_886_16041",
    x1: 81.4994,
    y1: 28.0103,
    x2: 52.2836,
    y2: 49.3453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_886_16041",
    x1: 76.9259,
    y1: 21.525,
    x2: 47.6036,
    y2: 42.9377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_886_16041",
    x1: 85.6866,
    y1: 33.7507,
    x2: 56.4633,
    y2: 55.0912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_886_16041",
    x1: 84.8596,
    y1: 32.741,
    x2: 55.7159,
    y2: 54.0234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_886_16041",
    x1: 71.9222,
    y1: 14.904,
    x2: 42.7103,
    y2: 36.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_886_16041",
    x1: 72.3621,
    y1: 15.5063,
    x2: 43.1498,
    y2: 36.8389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_886_16041",
    x1: 83.9677,
    y1: 31.3989,
    x2: 54.752,
    y2: 52.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_886_16041",
    x1: 78.6247,
    y1: 24.0944,
    x2: 49.4302,
    y2: 45.4139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_886_16041",
    x1: 69.4056,
    y1: 11.4611,
    x2: 40.2013,
    y2: 32.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_886_16041",
    x1: 69.3192,
    y1: 11.3899,
    x2: 40.1378,
    y2: 32.6998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#49A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    stopColor: "#59A545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#70AD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#8DBA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9616,
    stopColor: "#B1CC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_886_16041",
    x1: 101.796,
    y1: 21.0314,
    x2: 137.749,
    y2: 8.21424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_886_16041",
    x1: 104.737,
    y1: 29.3148,
    x2: 140.817,
    y2: 16.4523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_886_16041",
    x1: 108.712,
    y1: 40.4428,
    x2: 144.652,
    y2: 27.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_886_16041",
    x1: 107.211,
    y1: 36.2642,
    x2: 143.208,
    y2: 23.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_886_16041",
    x1: 106.528,
    y1: 34.2291,
    x2: 142.457,
    y2: 21.4205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_886_16041",
    x1: 108.367,
    y1: 39.4594,
    x2: 144.306,
    y2: 26.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_886_16041",
    x1: 99.4682,
    y1: 14.5568,
    x2: 135.444,
    y2: 1.73136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_886_16041",
    x1: 102.089,
    y1: 21.9239,
    x2: 138.058,
    y2: 9.10096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_886_16041",
    x1: 99.5194,
    y1: 14.6667,
    x2: 135.495,
    y2: 1.84123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_886_16041",
    x1: 98.6641,
    y1: 12.2728,
    x2: 134.618,
    y2: -0.544929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137EC0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_886_16041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 183,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.82424f7eabbdb7d2f6114b9cbeabd132.svg";
export { ForwardRef as ReactComponent };